import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "./UserContext";


const UserDropdown = ({setIsParentOpen=null}) => {
  const { user, setUser } = useUser();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const ownRef = useRef(null);
  const navigate = useNavigate();


  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      } else if (ownRef.current && ownRef.current.contains(event.target)) {
        setIsDropdownOpen((prev) => !prev);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  if (!user) {
    return null; // Hide if no user is logged in
  }

  const toggleDropdown = () => {
    //setIsDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    // Add logout logic here
    localStorage.clear()
    setUser(null)
    setIsDropdownOpen(false);
    if (setIsParentOpen) {
      setIsParentOpen(false);
    }
    //console.log("Logging out...");
  };

  const handleViewStats = () => {
    // Add navigation to stats page here
    //console.log(user)
    navigate(`/profiles/${user.display_name}`)
    setIsDropdownOpen(false);
    if (setIsParentOpen) {
      setIsParentOpen(false);
    }

  };

  return (
    <div className="relative"

    >
      {/* Avatar and Username */}
      <div
        className="flex items-center space-x-2 px-3 py-1 hover:text-pink-200 cursor-pointer duration-200 ease-in-out"
        ref={ownRef}
      >
        <img
          src={user.profile_image_url}
          alt=""
          className="w-6 h-6 rounded-full border border-gray-300"
          loading="lazy"
        />
        <span className="">{user.display_name}</span>
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div 
        ref={dropdownRef}
        className="ml-1 absolute mt-4 w-22 rounded-lg grid grid-cols-1 grid-rows-2 gap-1 items-center bg-gray-950/95 border border-pink-300/30 transition z-20">
            <div className="flex justify-center">
                <button
                type="button"
                onClick={handleViewStats}
                className="px-4 py-2 hover:bg-pink-400/30 focus:outline-none z-20"
                >
                <span className="">Profile</span>
                </button>
            </div>
            <div className="flex justify-center">
                <button
                type="button"
                onClick={handleLogout}
                className="px-4 py-2 hover:bg-pink-400/30 focus:outline-none z-20"
                >
                <span className="">Logout</span>
                </button>
            </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;